import React from 'react';
import PropTypes from 'prop-types';
import { TimePicker } from 'antd';
import moment from 'moment';
import styles from './styles.less';

function CustomTime({
  handleCustomTime,
  initialValues: { customDaytime, customDaytimeEnd },
  placeholder,
}) {
  const [allowedStartTime, setAllowedStartTime] = React.useState({});
  const [allowedEndTime, setAllowedEndTime] = React.useState({});

  React.useEffect(() => {
    handleCustomTime({ allowedStartTime, allowedEndTime });
  }, [allowedStartTime, allowedEndTime]);

  /* onChange functions */
  function onStartTimeChange(time) {
    // console.log(time.format('YYYY-MM-DD HH:mm:ss'))
    if (time) {
      // let allowedHour = time.hour();
      // let allowedMinute = time.minute();

      // if (allowedMinute < 30) {
      //   allowedMinute += 29;
      // } else {
      //   allowedMinute -= 31;
      //   allowedHour += 1;
      // }

      setAllowedStartTime(time);
    } else {
      setAllowedEndTime(null);
    }
  }

  function onEndTimeChange(time) {
    if (time) {
      // let allowedHour = time.hour();
      // let allowedMinute = time.minute();

      // if (allowedMinute >= 30) {
      //   allowedMinute -= 29;
      // } else {
      //   allowedMinute += 31;
      //   allowedHour -= 1;
      // }
      setAllowedEndTime(time);
    } else {
      setAllowedStartTime(null);
    }
  }

  /* disabledHours functions */
  function disabledHoursStartTime() {
    let hour;
    if (allowedStartTime && allowedStartTime.hour) {
      hour = allowedStartTime.hour;
    }
    const disabledHours = [];

    if (hour !== undefined) {
      for (let i = 1; i <= 12; ++i) {
        disabledHours.push(hour + i <= 23 ? hour + i : hour + i - 24);
      }
    }

    return disabledHours;
  }

  function disabledHoursEndTime() {
    let hour;
    if (allowedEndTime && allowedEndTime.hour) {
      hour = allowedEndTime.hour;
    }
    const disabledHours = [];

    if (hour !== undefined) {
      for (let i = 1; i <= 12; ++i) {
        disabledHours.push(hour - i >= 0 ? hour - i : hour - i + 24);
      }
    }

    return disabledHours;
  }

  /* disabledMinutes functions */
  function disabledMinutesStartTime(selectedHour) {
    let hour;
    let minute;
    if (allowedStartTime && allowedStartTime.hour && allowedStartTime.minute) {
      hour = allowedStartTime.hour;
      minute = allowedStartTime.minute;
    }
    const disabledMinutes = [];

    const disabledHours = [];

    if (hour !== undefined) {
      for (let i = 1; i <= 12; ++i) {
        disabledHours.push(hour + i <= 23 ? hour + i : hour + i - 24);
      }
    }

    if (disabledHours.includes(selectedHour)) {
      for (let i = 0; i <= 59; ++i) {
        disabledMinutes.push(i);
      }
    } else if (minute !== undefined && hour === selectedHour) {
      for (let i = minute; i <= 59; ++i) {
        disabledMinutes.push(i);
      }
    }

    return disabledMinutes;
  }

  function disabledMinutesEndTime(selectedHour) {
    let hour;
    let minute;
    if (allowedEndTime && allowedEndTime.hour && allowedEndTime.minute) {
      hour = allowedEndTime.hour;
      minute = allowedEndTime.minute;
    }
    const disabledMinutes = [];

    const disabledHours = [];

    if (hour !== undefined) {
      for (let i = 1; i <= 12; ++i) {
        disabledHours.push(hour - i >= 0 ? hour - i : hour - i + 24);
      }
    }
    if (disabledHours.includes(selectedHour)) {
      for (let i = 0; i <= 59; ++i) {
        disabledMinutes.push(i);
      }
    } else if (minute !== undefined && hour === selectedHour) {
      for (let i = 0; i <= minute; ++i) {
        disabledMinutes.push(i);
      }
    }

    return disabledMinutes;
  }

  return (
    <div className={styles.customTime}>
      <TimePicker
        format="HH:mm"
        onChange={onStartTimeChange}
        disabledHours={disabledHoursStartTime}
        disabledMinutes={disabledMinutesStartTime}
        defaultValue={customDaytime ? moment(customDaytime) : null}
        placeholder={placeholder}
      />

      <TimePicker
        format="HH:mm"
        onChange={onEndTimeChange}
        disabledHours={disabledHoursEndTime}
        disabledMinutes={disabledMinutesEndTime}
        defaultValue={customDaytimeEnd ? moment(customDaytimeEnd) : null}
        placeholder={placeholder}
      />
    </div>
  );
}

CustomTime.propTypes = {
  initialValues: PropTypes.object,
  handleCustomTime: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

CustomTime.defaultProps = {
  initialValues: {},
  placeholder: '',
};

export default CustomTime;
